import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { MenuCartAnonymousComponent } from './menu-cart-anonymous/menu-cart-anonymous.component';
import { MenuCartAuthenticatedComponent } from './menu-cart-authenticated/menu-cart-authenticated.component';

@Component({
  selector: 'py-menu-cart',
  templateUrl: './menu-cart.component.html',
  styleUrls: ['./menu-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MenuCartAnonymousComponent, MenuCartAuthenticatedComponent],
})
export class MenuCartComponent implements OnInit {
  isUserLoggedIn$: Observable<boolean>;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.isUserLoggedIn$ = this.authService.isUserLoggedIn();
  }
}
